import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Divider } from '@mui/material';
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';
import { Delete, Visibility } from '@mui/icons-material';

import { Job } from '@libs/models';
import { useJobSearchQuery } from '@carcareers/store';
import { DashboardPageContainer, Drawer, JobCreateForm } from '@carcareers/components';
import { useJob } from '@carcareers/hooks';
import { ADMIN_JOB_INDEX_COLUMNS, JOB_INDEX_COLUMN_INITIAL_STATE, routes } from '@carcareers/utils';
import { FormProvider, useDrawer } from '@carcareers/contexts';
import { DataGridV2 as DataGrid } from '@carcareers/components';

export const JobIndex: FC = () => {
  const navigate = useNavigate();
  const search = useJobSearchQuery;
  const { deleteJob } = useJob();
  const { setOpen } = useDrawer();

  const columns = [
    ...ADMIN_JOB_INDEX_COLUMNS,
    {
      field: 'actions',
      type: 'actions' as const,
      flex: 1,
      align: 'right' as const,
      headerAlign: 'right' as const,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          showInMenu
          key={`view-${params.row.id}`}
          label="View"
          icon={<Visibility />}
          onClick={() =>
            navigate(`/${routes.ADMIN_HOME}/${routes.ADMIN_JOBS_VIEW.replace(':id', params.row.id.toString())}`)
          }
        />,
        <GridActionsCellItem
          showInMenu
          key={`delete-${params.row.id}`}
          label="Delete"
          icon={<Delete color="error" />}
          onClick={() => deleteJob(params.row.id)}
        />,
      ],
    },
  ];

  return (
    <>
      <DashboardPageContainer>
        <DataGrid<Job>
          columns={columns}
          query={search}
          initialState={{
            columns: { columnVisibilityModel: JOB_INDEX_COLUMN_INITIAL_STATE },
          }}
          tools={
            <>
              <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
                Add
              </Button>
              <Divider orientation="vertical" sx={{ height: 24, ml: 1 }} />
            </>
          }
        />
      </DashboardPageContainer>
      <Drawer title="Add a Template" width={500}>
        <FormProvider>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%', p: 2 }}>
            <JobCreateForm />
          </Box>
        </FormProvider>
      </Drawer>
    </>
  );
};

export default JobIndex;
